import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import { currencies } from "../currencies"; // Import currencies

function BudgetInput({ budget, setBudget, currency }) {
  const handleChange = (e) => {
    let next = e.target.value;
    // Allow clearing while typing, but normalize leading zeros when a number is present
    if (next === '') {
      setBudget('');
      return;
    }
    if (/^0[0-9]+/.test(next) && !next.startsWith('0.')) {
      next = next.replace(/^0+/, '');
    }
    setBudget(next);
  };

  const handleBlur = () => {
    if (budget === '') {
      setBudget('0');
    }
  };

  return (
    <TextField
      label="Budget"
      type="number"
      variant="outlined"
      fullWidth
      value={budget}
      onChange={handleChange}
      onBlur={handleBlur}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            {currencies[currency].symbol}
          </InputAdornment>
        ),
      }}
      style={{ marginBottom: 20 }}
    />
  );
}

export default BudgetInput;
